import { render, staticRenderFns } from "./videoedit.vue?vue&type=template&id=007316a0&scoped=true"
import script from "./videoedit.vue?vue&type=script&lang=js"
export * from "./videoedit.vue?vue&type=script&lang=js"
import style0 from "./videoedit.vue?vue&type=style&index=0&id=007316a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007316a0",
  null
  
)

export default component.exports